const checaLogin = (props) => {
    let email = localStorage.getItem('CLLogin');

    // Verifica se o cookie CLLogin existe
    if (!email || email === "") {
        const cookies = document.cookie.split('; ');
        const clLoginCookie = cookies.find(row => row.startsWith('CLLogin='));

        if (clLoginCookie) {
            const cookieValue1 = clLoginCookie.split('=')[1];
            localStorage.setItem('CLLogin', decodeURIComponent(cookieValue1));
            email = cookieValue1;
        }

        const clSenhaCookie = cookies.find(row => row.startsWith('CLSenha='));

        if (clSenhaCookie) {
            const cookieValue2 = clSenhaCookie.split('=')[1];
            localStorage.setItem('CLSenha', cookieValue2);
        }

        const clTokenCookie = cookies.find(row => row.startsWith('CLToken='));

        if (clTokenCookie) {
            const cookieValue3 = clTokenCookie.split('=')[1];
            localStorage.setItem('CLToken', cookieValue3);
        }
    }

    // Redireciona para login se não houver email
    if (!email || email === "") {
        props.history.push('/login');
    }
};

export default checaLogin;